<template>
  <div class="edit">
    <mu-dialog title="个人资料" width="500" :open="open" @close="close">
      <mu-form :model="editForm" label-position="left" label-width="80">
        <mu-form-item prop="userName" label="用户名">
          <mu-text-field v-model="editForm.userName"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="realName" label="真实姓名">
          <mu-text-field v-model="editForm.realName" disabled></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="phone" label="手机">
          <mu-text-field v-model="editForm.phone"></mu-text-field>
        </mu-form-item>
        <mu-form-item>
          <mu-button color="primary" @click="submit">确定修改</mu-button>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import session from 'utils/session'
import api from '@/api'
import Password from './password'
export default {
  components: { Password },
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {}
    }
  },
  methods: {
    submit() {
      backend(api.user.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.$toast.success('设置成功,请重新登录')
          session.removeSession('user')
          backend(api.auth.logout).then(() => {
            this.$router.replace('/login')
          })
          this.close()
          this.$emit('editFinished')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    password() {
      this.passwordOpen = true
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.edit {
}
</style>



// WEBPACK FOOTER //
// src/views/admin/profile.vue